import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import AdminAdd from "@/pages/AdminAdd";

function App() {
  return (
    <div className="App" dir="rtl">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/add" element={<AdminAdd />} />
          <Route path="/admin/edit/:id" element={<AdminAdd />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-center" dir="rtl" />
    </div>
  );
}

export default App;
